import React from 'react'
import RaisedButton from 'material-ui-legacy/RaisedButton'
import ActionDone from 'material-ui-legacy/svg-icons/action/done'

const SaveButton = (props) => (
  <RaisedButton
    style={props.style || {margin: '5px'}}
    onTouchTap={props.onTouchTap}
    label={props.label || "Save"}
    labelPosition="after"
    primary={true}
    icon={props.icon || <ActionDone/>}
    {...props}
  />
)

export default SaveButton



// WEBPACK FOOTER //
// ./src/components/UI/SaveButton.jsx